// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBox_searchBox__1M5MS","icon":"SearchBox_icon__d5jgX"};